import { Longhand } from "../longhand.js";
import Base from "./border-top-left-radius.js";
/**
 * {@link https://developer.mozilla.org/en-US/docs/Web/CSS/border-bottom-right-radius}
 * @internal
 */
export default Longhand.extend(Base);
//# sourceMappingURL=border-bottom-right-radius.js.map